import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.1665 15H10.8332V13.3333H9.1665V15ZM9.99984 1.66666C5.39984 1.66666 1.6665 5.39999 1.6665 9.99999C1.6665 14.6 5.39984 18.3333 9.99984 18.3333C14.5998 18.3333 18.3332 14.6 18.3332 9.99999C18.3332 5.39999 14.5998 1.66666 9.99984 1.66666ZM9.99984 16.6667C6.32484 16.6667 3.33317 13.675 3.33317 9.99999C3.33317 6.32499 6.32484 3.33332 9.99984 3.33332C13.6748 3.33332 16.6665 6.32499 16.6665 9.99999C16.6665 13.675 13.6748 16.6667 9.99984 16.6667ZM9.99984 4.99999C8.15817 4.99999 6.6665 6.49166 6.6665 8.33332H8.33317C8.33317 7.41666 9.08317 6.66666 9.99984 6.66666C10.9165 6.66666 11.6665 7.41666 11.6665 8.33332C11.6665 9.99999 9.1665 9.79166 9.1665 12.5H10.8332C10.8332 10.625 13.3332 10.4167 13.3332 8.33332C13.3332 6.49166 11.8415 4.99999 9.99984 4.99999Z",
		fill: "#697186"
	})
});
export default SvgQuestionCircle;
